<template>
    <div class="target-config-input-container">
        <div class="target-tab-container">
            <template v-if="tabList.length">
                <div
                    :class="[
                        'tab-list',
                        { 'tab-active': tabActive == item.target_main_id }
                    ]"
                    v-for="item in tabList"
                    :key="item.target_main_id"
                    @click="changTarget(item.target_main_id)"
                >{{ item.target_name }}</div>
            </template>
            <template v-else>
                <div class="no-data">暂无数据</div>
            </template>
        </div>
        <div class="other-container">
            <!-- <div class="tree-wrap-container">
                <me-tree
                    ref="myPointTree"
                    :treeData="pointData"
                    :treeToolBar="false"
                    :defaultProps="defaultProps"
                    :defaultExpandedKeys="defaultPointCheckKeys"
                    :nodeKey="'point_id'"
                    :defaultExpandAll="false"
                    @handleTreeNodeClick="handlePointNodeClick"
                ></me-tree>
            </div>-->
            <div class="table-wrap">
                <div class="button-wrap">
                    <!-- <el-button class="leader-common-button">查询</el-button> -->
                    <el-form
                        :model="addForm"
                        ref="addForm"
                        label-width="80px"
                        class="leader-style-form"
                    >
                        <!-- :disabled="show_day.length" -->
                        <el-form-item prop="searchDate" label="月份">
                            <el-date-picker
                                v-model="searchDate"
                                type="monthrange"
                                range-separator="至"
                                start-placeholder="开始月份"
                                end-placeholder="结束月份"
                                value-format="yyyy-MM"
                            ></el-date-picker>
                        </el-form-item>
                    </el-form>
                    <div class="button-inner">
                        <el-button class="leader-common-button" @click="getShowDayList">查询</el-button>
                        <el-button
                            class="leader-common-button"
                            @click="showInputDialog({}, '新增')"
                        >增加</el-button>
                    </div>
                </div>
                <el-table :data="tableData" ref="multipleTable" border class="leader-style-table">
                    <el-table-column
                        type="index"
                        width="50"
                        align="center"
                        label="序号"
                        property="num"
                    ></el-table-column>
                    <el-table-column align="center" label="月份" property="show_day"></el-table-column>
                    <el-table-column align="center" label="录入/总计">
                        <template slot-scope="scope">
                            <span
                                v-if="
                                    scope.row.compared !=
                                    scope.row.compared_count
                                "
                                :style="{
                                    color: '#f66f6a'
                                }"
                            >{{ scope.row.compared }}</span>
                            <span v-else>{{ scope.row.compared }}</span>
                            /{{ scope.row.compared_count }}
                        </template>
                    </el-table-column>
                    <!-- <el-table-column
                        v-for="(column, index) in tableColum"
                        :key="index"
                        align="center"
                        :label="column.column_name"
                        :property="column.target_main_dtl_id"
                    ></el-table-column>
                    -->
                    <el-table-column label="操作" width="150" align="center">
                        <template slot-scope="scope">
                            <!-- <el-button
                                @click="showInputDialog(scope.row, '修改')"
                                type="text"
                                class="leader-button edit-button"
                            >
                                <i class="iconfont iconeditor"></i>
                                <span class="inner-text">修改</span>
                            </el-button>-->
                            <el-button
                                @click="showInputDialog(scope.row, '修改')"
                                type="text"
                                size="medium"
                                class="button-modify"
                            >修改</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <!-- :point_id="pointActive" -->
        <input-add-dialog
            :title="title"
            :dialogVisible.sync="dialogVisible"
            :target_main_id="tabActive"
            :show_day="show_day"
        ></input-add-dialog>
    </div>
</template>
<script>
import * as api from "@/http/target-config.js";
import Tree from "@/comon/components/tree.vue";
import InputAddDialog from "./components/input-add-dialog.vue";
export default {
    components: {
        "me-tree": Tree,
        "input-add-dialog": InputAddDialog
    },
    data() {
        return {
            defaultProps: {
                children: "childList",
                label: "point_name"
            },
            pointData: [],
            pointActive: "",
            pointActiveObj: {},
            tabList: [],
            tabActive: "",
            tableData: [],
            tableList: [],
            tableColum: [],
            title: "新增",
            dialogVisible: false,
            loading: false,
            show_day: "",
            searchDate: ["", ""]
        };
    },
    created() {
        this.getIsCollectedList();
    },
    methods: {
        // 获取指标list
        getIsCollectedList() {
            api.getIsCollectedList().then(res => {
                if (res && res.error_code === "0") {
                    this.tabList = res.bus_json;
                    this.tabActive =
                        res.bus_json[0] && res.bus_json[0].target_main_id;
                    // this.getUnitPointList(this.tabActive);
                    // this.getTargetMainDtlList();
                    if (this.tabActive && this.tabActive.length)
                        this.getShowDayList();
                }
            });
        },
        getShowDayList() {
            this.loading = true;
            api.getShowDayList({
                target_main_id: this.tabActive,
                start_day: (this.searchDate && this.searchDate[0]) || "",
                end_day: (this.searchDate && this.searchDate[1]) || ""
            }).then(res => {
                if (res && res.error_code === "0") {
                    this.tableData = res.bus_json;
                }
                this.loading = false;
            });
        },
        /**
         * 获取采集点信息
         */
        getUnitPointList(pointId) {
            api.getTargetPointList({
                target_main_id: pointId
            }).then(res => {
                if (res && res.error_code === "0") {
                    this.pointData = res.bus_json;
                    // let formatData = this.tickMenuIdFilter().filter(
                    //     res.bus_json
                    // );
                    this.defaultPointCheckKeys = [
                        res.bus_json[0] && res.bus_json[0].point_id
                    ];
                    this.pointActive =
                        (res.bus_json[0] && res.bus_json[0].point_id) || "";
                    this.pointActiveObj = res.bus_json[0] || {};
                    this.$nextTick(() => {
                        this.$refs.myPointTree.$refs.tree.setCurrentKey(
                            res.bus_json[0] && res.bus_json[0].point_id
                        );
                    });
                    if (this.pointActive) {
                        this.getTargetMainDtlList();
                    } else {
                        this.tableData = [];
                    }
                }
            });
        },
        handlePointNodeClick(value) {
            if (value.state == "1") {
                this.$message({
                    message: "采集点下没有采集器",
                    type: "warning"
                });
                return;
            }
            this.pointActive = value.point_id;
            this.pointActiveObj = value;
            this.getTargetMainDtlList();
        },
        /**
         * 格式化tree disabled状态；
         */
        tickMenuIdFilter: () => {
            let resultArr = new Array();
            let firstPoint = new Object();
            let getTickMenuId = function (obj) {
                if (
                    undefined === obj ||
                    null === obj ||
                    !(obj instanceof Object)
                ) {
                    return;
                }
                if (obj.state === "1") {
                    //实采集点
                    obj.disabled = true;
                    resultArr.push(obj.id);
                } else if (obj.state === "0") {
                    //虚点
                    if (!firstPoint.point_id) {
                        firstPoint = obj;
                    }
                }

                if (null != obj.childList && obj.childList instanceof Array) {
                    for (let child of obj.childList) {
                        getTickMenuId(child);
                    }
                }
            };

            return {
                filter: function (arr) {
                    if (!(arr instanceof Array)) {
                        return false;
                    }
                    resultArr = new Array();
                    firstPoint = new Object();
                    for (let rootMenu of arr) {
                        getTickMenuId(rootMenu);
                    }
                    return { tree: resultArr, firstPoint: firstPoint };
                }
            };
        },
        // 选中指标
        changTarget(targetId) {
            this.tabActive = targetId;
            this.searchDate = ["", ""];
            this.getShowDayList();
        },

        //显示新增或者修改弹窗
        showInputDialog(row, title) {
            // if (!this.pointActive) {
            //     this.$message({
            //         message: "请选择采集点",
            //         type: "warning",
            //     });
            //     return;
            // }
            if (!this.tabActive) {
                this.$message({
                    message: "无指标数据",
                    type: "warning"
                });
                return;
            }
            this.title = title;
            this.show_day = row.show_day || "";
            this.dialogVisible = true;
        }
    }
};
</script>
<style lang="scss">
.target-config-input-container {
    width: 100%;
    height: calc(100% - 40px);
    display: inline-flex;
    .el-range-editor .el-range-input {
        background: transparent;
        //  color: #fff;
    }
    .el-date-editor .el-range-separator {
        color: #fff;
    }
    .leader-style-table {
        background-color: transparent;
    }
    .leader-style-table::before {
        height: 0;
    }
    .no-data {
        text-align: center;
        color: #fff;
        font-size: 14px;
    }
    .target-tab-container {
        width: px2Rem(280px);
        height: 100%;
        // border-right: 1px solid #56fcff;
        .tab-list {
            width: 200px;
            height: 34px;
            line-height: 34px;
            text-align: center;
            margin: 0 auto 20px auto;
            font-size: 14px;
            // color: #56fcff;
            // border: 1px solid #56fcff;
            color: #fff;
            border-radius: 8px;
            cursor: pointer;
        }
    }
    .tab-active {
        //background: #f66f6a;
        color: #fff !important;
        border-color: #f66f6a !important;
    }
    .other-container {
        width: calc(100% - #{px2Rem(280px)});
        display: inline-flex;
        justify-content: space-between;
        height: 100%;
        .tree-wrap-container {
            width: px2Rem(280px);
            height: 100%;
        }
        .table-wrap {
            // width: calc(100% - 280px - 40px);
            width: calc(100% - 40px);
            height: 100%;
            .button-wrap {
                width: 100%;
                display: inline-flex;
                align-items: center;
                justify-content: space-between;
                // text-align: right;
                margin-bottom: 10px;
            }
        }
    }
}
</style>
